<template>
  <div>
    <div class="container">
      <div class="youthIntro">
        <img src="@/assets/img/team/youth/history.png" alt="history"/>
      </div>
    </div>

    <!-- //리스트 -->
  </div>
</template>

<script>
export default {
  name: 'teamYouthHistory',
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
